export default {
	title: 'मेरी प्रोफ़ाइल',
	messages: {
		choose_plan: 'एक प्लान चुनें',
		unlock_immediately: 'सभी सुविधाएँ तुरंत अनलॉक करें',
		current_subscription: 'आपकी वर्तमान सदस्यता'
	},
	language: {
		title: 'भाषा',
		description: 'इंटरफ़ेस की भाषा चुनें',
		languages: {
			de: 'जर्मन',
			en: 'अंग्रेज़ी',
			es: 'स्पेनिश',
			fr: 'फ़्रेंच',
			hi: 'हिन्दी',
			it: 'इतालवी',
			ja: 'जापानी',
			pt: 'पुर्तगाली',
			zh: 'चीनी (मंदारिन)'
		}
	},
	theme: {
		title: 'थीम चयन'
	},
	actions: {
		manage_subscription: 'मेरी सदस्यता प्रबंधित करें'
	},
	api_access: {
	  title: "API एक्सेस (MCP सर्वर)",
	  description: "AI एजेंट्स (Claude, ChatGPT, आदि) को Model Context Protocol के माध्यम से आपके Gerositus प्रोजेक्ट्स तक पहुँच की अनुमति देता है। टोकन आपके समान एक्सेस देता है — गोपनीय रखें।",
	  endpoint: "MCP एंडपॉइंट URL",
	  no_token: "अभी कोई टोकन नहीं — AI एजेंट एक्सेस सक्षम करने के लिए एक उत्पन्न करें।",
	  default_token_name: "डिफ़ॉल्ट टोकन",
	  status_active: "सक्रिय",
	  status_revoked: "रद्द",
	  created_at: "{{date}} को बनाया गया",
	  last_used_at: "अंतिम उपयोग {{date}}",
	  never_used: "अब तक उपयोग नहीं",
	  generate: "टोकन उत्पन्न करें",
	  regenerate: "टोकन नवीनीकृत करें",
	  revoke: "टोकन रद्द करें",
	  copy: "कॉपी करें",
	  copied: "क्लिपबोर्ड पर कॉपी किया",
	  copy_failed: "कॉपी विफल",
	  config_example: "MCP क्लाइंट कॉन्फ़िगरेशन उदाहरण",
	  reveal_title: "अभी अपना टोकन सहेजें",
	  reveal_done: "मैंने सहेज लिया",
	  reveal_warning_title: "यह टोकन देखने का यह एकमात्र अवसर है",
	  reveal_warning_body: "इसे सुरक्षित स्थान (पासवर्ड मैनेजर) में कॉपी करें। खोने पर नवीनीकृत करना होगा। इस टोकन वाला कोई भी आपके प्रोजेक्ट पढ़ सकता है।",
	  regenerate_confirm_title: "एक्सेस टोकन नवीनीकृत करें?",
	  regenerate_confirm_body: "वर्तमान टोकन तुरंत रद्द हो जाएगा और नया जारी किया जाएगा। पुराने टोकन का उपयोग करने वाले AI एजेंट्स को पुनः कॉन्फ़िगर करना होगा।",
	  revoke_confirm_title: "एक्सेस टोकन रद्द करें?",
	  revoke_confirm_body: "इस टोकन का उपयोग करने वाले AI एजेंट्स एक्सेस खो देंगे। आप कभी भी नया उत्पन्न कर सकते हैं।"
	}
};
